const SESSION_STORAGE = {
  IS_WHATS_NEW_DISMISSED: 'is_whats_new_dismissed',
  IS_POLYGON_NOTICE_DISMISSED: 'is_polygon_notice_dismissed',
} as const;

export { SESSION_STORAGE, SESSION_STORAGE as SS };
